<template>
  <!-- Table Container Card -->
  <b-card>

    <validation-observer ref="nfiuReportRules">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="match-height">
          <!-- Start Date-->
          <b-col md="3">
            <DatePickerField
              id="start-date"
              v-model="nfiuReportFormData.startDate"
              :min-date="new Date()"
              :label="$t('Start Date')"
              :error-name="$t('Start Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
              rules="required"
            />
          </b-col>
          <!--  Start Date -->

          <!-- End Date-->
          <b-col md="3">
            <DatePickerField
              id="end-date"
              v-model="nfiuReportFormData.endDate"
              :min-date="new Date()"
              :label="$t('End Date')"
              :error-name="$t('End Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
              rules="required"
            />
          </b-col>
          <!--  End Date -->

          <b-col
            md="4"
            class="mt-2"
          >
            <Button
              v-if="getUserPermission('EXPORT_NFIU_REPORT')"
              :label="$t('Generate Report')"
              :loading="isLoading"
              :disabled="isDisabled"
              variant="primary"
              size="md"
              @click="handleSubmit"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BForm, BCol,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import {
  toYearWithDate, toCustomDate, getDate, toDateWithYear,
} from '@/helpers/formatDate'
import { toBalance, formatAmount, toFormatAmount } from '@/helpers/formatAmount'
import 'jspdf-autotable'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'
import getStatusColor from '../../../../helpers/getStatusColor'
import { reportPermissions } from '../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    Button,
    DatePickerField,
    ValidationObserver,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toBalance,
      toFormatAmount,
      isBusy: false,
      isDisabledText: false,
      required,
      isLoading: false,
      isDisabled: false,
      showSpinner: false,
      getStatusColor,
      toDateWithYear,
      nfiuReportFormData: {
        startDate: null,
        endDate: null,
      },
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        maxDate: '',
        defaultDate: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      currentFinancialDate: 'operations/getCurrentFinancialDate',
      institutionDetails: 'auth/getInstitution',
      userDetails: 'auth/getCurrentUser',
    }),
    getInstitutionFinancialDate() {
      return getDate(this.currentFinancialDate.financialDate)
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.generateNFIUReport()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.generateNFIUReport()
    },
  },
  mounted() {
    this.datePickerConfig.maxDate = this.getInstitutionFinancialDate
  },
  methods: {
    ...mapActions({
      downloadAMLReports: 'reports/downloadAMLReports',
    }),
    handleSubmit() {
      this.$refs.nfiuReportRules.validate().then(async success => {
        if (success) {
          this.exportToExcel()
        }
      })
    },
    async exportToExcel() {
      try {
        this.isDisabled = true
        this.isLoading = true
        this.showSpinner = true
        const search = {
          StartDate: this.nfiuReportFormData.startDate ? toYearWithDate(this.nfiuReportFormData.startDate) : null,
          EndDate: this.nfiuReportFormData.startDate ? toYearWithDate(this.nfiuReportFormData.endDate) : null,
        }
        const response = await this.downloadAMLReports({
          search,
          fileExportFormat: 0,
          permission: reportPermissions.EXPORT_NFIU_REPORT,
        })
        if (response.status === 200) {
          this.alertSuccessCustom({
            text: this.$t('Your download is in progress and might take a little longer. Go to your'),
            link: {
              text: this.$t('Download Manager'),
              route: { name: 'download-manager' },
            },
            afterLinkText: this.$t('to access the completed file.'),
          })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isDisabled = false
        this.isLoading = false
        this.showSpinner = false
      }
    },

    formatCustomDate: toCustomDate,
    toAmount: formatAmount,
  },
}
</script>

  <style lang="scss">
     @import '@core/scss/vue/libs/vue-select.scss';
  </style>
